import 'preact/debug';
import { render } from 'preact'
import { App } from './App'
import { WishlistProvider } from './contexts/WishlistContext'
import './styles/global.css'

//FOR DEV use the following lines
// viewType "frontpage" oder irgenwas anderes
// const viewType = 'frontpage';
// const viewType = 'facet';
// const containers:any[] = [];

const isDev = process.env.NODE_ENV === 'development' || !process.env.NODE_ENV;

if (isDev) {
    const toolTipTexts = '{"reiseart":{"Anreise am Landweg":"<p>Test Landweg Tooltiop<\\/p>\\n"},"interesse":{"Yoga":"<p>tool Tip Yoga Test<\\/p>\\n"},"unterkunft":{"Boot":"<p>Boot tool Tip Test<\\/p>\\n"},"anreiseart":{"Flugreise":"<p>Anreiseart Demo Flugreise213<\\/p>\\n"},"difficulty":{"leicht":"Das Hauptaugenmerk liegt auf der Begegnung mit Land und Kultur. Besondere Kondition ist nicht erforderlich. Gehzeiten max. 2-3 Std. am Tag.","einfach":"Genussvolles Erleben der Natur steht im Vordergrund. Wanderungen auf meist leicht begehbaren Wegen. Gute Grundkondition ist ausreichend. Gehzeiten bis ca. 4-5 Std. am Tag.","mittel":"F\u00fcr alle, die ihre Kondition auch im Alltag trainieren. Trittsicherheit ist manchmal erforderlich. Gehzeiten bis ca. 4-6 Std. am Tag. Es k\u00f6nnen auch ein bis zwei etwas l\u00e4ngere Tage dabei sein.","anspruchsvoll":"Touren mit sportlicherem Anspruch. Vor der Abreise sollten Sie Ihre Kondition bewusst trainieren. Trittsicherheit ist erforderlich. Gehzeiten bis ca. 6-8 Std. am Tag.","herausfordernd":"Sehr anspruchsvolle Touren. Hervorragende Ausdauer, Trittsicherheit, Trekkingerfahrung und eine sehr gute Kondition unbedingt erforderlich. Gehzeiten laut Detailprogramm."},"travel":{"Hotel":"Die \u00dcbernachtungen finden in festen Unterk\u00fcnften statt 1. N\u00e4here Details finden Sie im Tagesablauf oder in den Leistungen der Reise.","Jurte":"Die \u00dcbernachtungen finden in Zelten statt. N\u00e4here Details finden Sie im Tagesablauf oder in den Leistungen der Reise.","Zelt":"Die \u00dcbernachtungen finden in Zelten statt. N\u00e4here Details finden Sie im Tagesablauf oder in den Leistungen der Reise.2"}}';
    const contentInfusion = '[{"datetime_from":"2025-12-03 00:00:00","datetime_to":"2026-10-15 00:00:00","style":{"value":"1","label":"Katalog"},"title":"Unser neuer Katalog!","image":"https:\\/\\/www.weltweitwandern.at\\/wp-content\\/uploads\\/2025\\/12\\/content-infusion-katalog-2025.jpg","stamp":"https:\\/\\/www.weltweitwandern.at\\/wp-content\\/uploads\\/2025\\/12\\/katalog-2025-stempel.png","stamp_position_x":"82","stamp_position_y":"52","cta":{"title":"Katalog bestellen","url":"https:\\/\\/www.weltweitwandern.at\\/service\\/katalog-bestellen\\/?utm_source=website&utm_medium=contentinfusion&utm_campaign=katalog2026-27#bestellen","target":""}},{"datetime_from":"2025-12-04 16:40:27","datetime_to":"2026-01-15 23:59:00","style":{"value":"2","label":"Gewinnspiel"},"title":"Jahres-<br \\/>\\r\\ngewinnspiel","image":"https:\\/\\/www.weltweitwandern.at\\/wp-content\\/uploads\\/2025\\/12\\/jahresgewinnspiel-2025-bild.jpg","stamp":"https:\\/\\/www.weltweitwandern.at\\/wp-content\\/uploads\\/2025\\/12\\/jahresgewinnspiel-2025-stempel.png","stamp_position_x":"35","stamp_position_y":"35","cta":{"title":"Jetzt mitmachen","url":"https:\\/\\/www.weltweitwandern.at\\/jahresgewinnspiel\\/?utm_source=website&utm_medium=contentinfusion&utm_campaign=jahresgewinnspiel","target":""}},{"datetime_from":"2025-12-04 16:41:56","datetime_to":"2026-06-30 23:59:00","style":{"value":"3","label":"Bring your friend"},"title":"Freund:innen werben &<br \\/>\\r\\nbelohnt werden","image":"https:\\/\\/www.weltweitwandern.at\\/wp-content\\/uploads\\/2025\\/12\\/bring-your-friend-2025-bild.jpg","stamp":"https:\\/\\/www.weltweitwandern.at\\/wp-content\\/uploads\\/2025\\/12\\/bring-your-friend-2025-stempel.png","stamp_position_x":"75","stamp_position_y":"25","cta":{"title":"Zur Aktion","url":"https:\\/\\/www.weltweitwandern.at\\/service\\/bringyourfriend\\/?utm_source=website&utm_medium=contentinfusion&utm_campaign=bringyourfriend","target":""}}]'
    // const contentInfusion = ''
    // const prefillFilters = '{"destination":{"show":false,"selected":["Europa","Anden"]},"reiseart":{"show":true,"selected":[]},"anreiseart":{"show":false,"selected":["Flugreise"]},"interesse":{"show":true,"selected":[]},"unterkunft":{"show":true,"selected":[]}}';
    const prefillFilters = '{}';
    const kuratierteReisen = '{"kuratierte_reisen":[{"value":"Amerika"},{"value":"\u00c4gypten"},{"value":"\u00c4thiopien"},{"value":"Algerien"},{"value":"Albanien"}]} ';
    const searchRedirects = '[{"term":"Berge","target":"http://weltweitwandern.at.localhost/afrika/"}]';
    const grundsortierung = ' {"reiseart":["Wanderreise","Trekkingreise"],"unterkunft":["Hotel","Zelt"],"veranstalter":["Weltweitwandern"]} ';

    //@ts-ignore
    const pageSize = contentInfusion === '' ? 12 : 11;

    // Toggle to test the query-string sync locally (mirrors the block's ACF field, default off)
    const enableQueryStringSync = true;

    render(
        <WishlistProvider>
            <App
                viewType='frontpaged'
                contentInfusion={contentInfusion}
                toolTipTexts={toolTipTexts}
                prefillFilters={prefillFilters}
                kuratierteReisen={kuratierteReisen}
                searchRedirects={searchRedirects}
                grundsortierung={grundsortierung}
                pageSize={pageSize}
                enableQueryStringSync={enableQueryStringSync}
                showSearchUrl={true}
            />
        </WishlistProvider>,
        document.getElementById('app')!
    )
} else {
    //FOR LIVE use the following lines
    const containers = document.querySelectorAll('.search-container');

    function collectAppStyles(): string {
        let cssText = '';

        // Collect styles from all stylesheets that might belong to our app
        for (const stylesheet of Array.from(document.styleSheets)) {
            try {
                // Only include styles from our app (you might want to refine this filter)
                if (stylesheet.href && stylesheet.href.includes('travel-search-frontend')) {
                    for (const rule of Array.from(stylesheet.cssRules)) {
                        cssText += rule.cssText;
                    }
                }
            } catch (e) {
                // Handle CORS issues with external stylesheets
                console.warn('Cannot access stylesheet:', stylesheet.href, e);
            }
        }

        return cssText;
    }

    function get_json_from_script_tag(container: HTMLElement, dataParameter: string) {
        const ref = container.dataset[dataParameter] as string;

        if (ref === null) {
            return '';
        }

        const scriptElement = document.getElementById(ref) ?? null;

        if (!scriptElement) {
            return '';
        }

        return scriptElement.textContent.trim()

    }

    if(containers && containers.length > 0) {
        containers.forEach((container) => {
            const viewType = (container as HTMLElement).dataset.viewType || "frontpage";
            const enableQueryStringSync = (container as HTMLElement).dataset.enableQueryString === 'true';
            const showSearchUrl = (container as HTMLElement).dataset.showSearchUrl === 'true';

            //fetch content infusion data
            const contentInfusion = get_json_from_script_tag(container as HTMLElement, 'contentInfusionRef')
            const toolTipTexts = get_json_from_script_tag(container as HTMLElement, 'tooltipTextsRef')
            const prefillFilters = get_json_from_script_tag(container as HTMLElement, 'prefillFiltersRef')
            const kuratierteReisen = get_json_from_script_tag(container as HTMLElement, 'kuratierteReisenRef')
            const searchRedirects = get_json_from_script_tag(container as HTMLElement, 'searchRedirectsRef')
            const grundsortierung = get_json_from_script_tag(container as HTMLElement, 'grundsortierungRef')
            const alternativeTexts = get_json_from_script_tag(container as HTMLElement, 'alternativeTextsRef')
            const pageSize = contentInfusion === '' ? 12 : 11;

            // Create Shadow DOM for CSS isolation
            const shadowRoot = (container as HTMLElement).attachShadow({ mode: 'open' });

            // Create skeleton loader overlay to prevent layout shift
            const skeletonOverlay = document.createElement('div');
            skeletonOverlay.innerHTML = `
                <div class="skeleton-overlay">
                    <div class="skeleton-loader">
                        <div class="skeleton-search-bar"></div>
                    </div>
                </div>
            `;
            shadowRoot.appendChild(skeletonOverlay);

            // Import styles into Shadow DOM
            const style = document.createElement('style');

            // Function to load styles and hide skeleton
            const loadStylesAndRender = () => {
                style.textContent = collectAppStyles();
                shadowRoot.appendChild(style);

                // Create a container div inside the shadow root
                const shadowContainer = document.createElement('div');
                shadowContainer.style.opacity = '0';
                shadowContainer.style.transition = 'opacity 0.3s ease-in-out';
                shadowRoot.appendChild(shadowContainer);

                // Render the app
                render(
                    <WishlistProvider>
                        <App
                            viewType={viewType}
                            contentInfusion={contentInfusion}
                            toolTipTexts={toolTipTexts}
                            prefillFilters={prefillFilters}
                            kuratierteReisen={kuratierteReisen}
                            searchRedirects={searchRedirects}
                            grundsortierung={grundsortierung}
                            alternativeTexts={alternativeTexts}
                            pageSize={pageSize}
                            enableQueryStringSync={enableQueryStringSync}
                            showSearchUrl={showSearchUrl}
                        />
                    </WishlistProvider>,
                    shadowContainer
                );

                // Wait for next frame to ensure styles are applied, then fade in content
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        shadowContainer.style.opacity = '1';
                        skeletonOverlay.style.opacity = '0';
                        setTimeout(() => {
                            if (skeletonOverlay.parentNode) {
                                skeletonOverlay.parentNode.removeChild(skeletonOverlay);
                            }
                        }, 300);
                    }, 100);
                });
            };

            // In development, we might need to wait for styles to load
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', loadStylesAndRender);
            } else {
                loadStylesAndRender();
            }
        })
    }

}


